import styled from 'styled-components';

import StyledImage from '../shared/StyledImage';
import StyledText from '../shared/StyledText';
import { TABLET_SIZE } from '../../constants';
import { withI18next } from '../../lib/withI18next';

const Container = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-end;

  @media (max-width: ${TABLET_SIZE}) {
    width: 250px;
    align-items: center;
    margin: 30px auto;
  }
`;

const StyledClaim = styled(StyledText)`
  text-align: center;
`;

const CompanyInfo = ({ t }) => (
  <Container>
    <StyledImage
      href="https://www.inventi.cz/"
      src="/static/inventi-logo.svg"
      alt="INVENTI"
      height="30px"
      margin="0 0 5px 0"
    />
    <StyledClaim>{t('COMPONENTS_FOOTER_CLAIM')}</StyledClaim>
    <StyledText>© INVENTI</StyledText>
  </Container>
);

export default withI18next()(CompanyInfo);



// WEBPACK FOOTER //
// components/Footer/CompanyInfo.js